import { getEnv } from '../../../../env';
import { ThemeLayerConfig } from '../../themeLayerConfigApi';
const env = getEnv();

export const borderConfig: ThemeLayerConfig = {
  categories: [
    {
      id: 'borders',
      groupid: 3,
      name: {
        nb: 'Grenser',
        nn: 'Grenser',
        en: 'Borders',
      },
    },
    {
      id: 'maritime_borders',
      groupid: 3,
      name: {
        nb: 'Maritime grenser',
        nn: 'Maritime grenser',
        en: 'Maritime borders',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.nmg',
      infoFormat: 'text/plain',
      parentId: 'borders',
    },
    {
      id: 'maritime_areas',
      groupid: 3,
      name: {
        nb: 'Maritime områder',
        nn: 'Maritime område',
        en: 'Maritime areas',
      },
      wmsUrl: 'https://wms.geonorge.no/skwms1/wms.nmg',
      infoFormat: 'text/plain',
      parentId: 'borders',
    },
  ],
  layers: [
    {
      id: 'osloMarkaBorder',
      name: {
        nb: 'Markagrensen',
        nn: 'Markagrensa',
        en: 'Oslo Marka border',
      },
      layers: 'Markagrensen',
      categoryId: 'borders',
      wmsUrl: env.layerProviderParameters.geoNorgeWMS.baseUrl + '.markagrensen',
      groupid: 3,
      legacyId: 'norgeskart.1026',
      queryable: false,
    },
    {
      id: 'countyBorders',
      name: {
        nb: 'Fylkesgrenser',
        nn: 'Fylkesgrenser',
        en: 'County borders',
      },
      layers: 'fylker',
      categoryId: 'borders',
      wmsUrl: env.layerProviderParameters.geoNorgeWMS.baseUrl + '.adm_enheter2',
      groupid: 3,
      queryable: false,
      useLegendGraphic: true,
    },
    {
      id: 'municipalityBorders',
      name: {
        nb: 'Kommunegrenser',
        nn: 'Kommunegrenser',
        en: 'Municipality borders',
      },
      layers: 'kommuner',
      categoryId: 'borders',
      wmsUrl: env.layerProviderParameters.geoNorgeWMS.baseUrl + '.adm_enheter2',
      groupid: 3,
      queryable: false,
      useLegendGraphic: true,
    },
    // --- Maritime grenser layers ---
    {
      id: 'sjoAvgrensningslinje_for_sokkel',
      name: {
        nb: 'Avgrensningslinje for sokkel',
        nn: 'Avgrensningslinje for sokkel',
        en: 'Delimitation line for continental shelf',
      },
      layers: 'avgrensningslinje_for_sokkel',
      categoryId: 'maritime_borders',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoSokkelgrense',
      name: {
        nb: 'Yttergrense for Norges kontinentalsokkel',
        nn: 'Yttergrense for Noregs kontinentalsokkel',
        en: "Outer limit of Norway's continental shelf",
      },
      layers: 'Sokkelgrense',
      categoryId: 'maritime_borders',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjo200_nautiske_mil',
      name: {
        nb: '200 nautiske mil',
        nn: '200 nautiske mil',
        en: '200 nautical miles',
      },
      layers: '200_nautiske_mil',
      categoryId: 'maritime_borders',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoAvtaltAvgrensningslinje',
      name: {
        nb: 'Avtalt avgrensningslinje',
        nn: 'Avtalt avgrensingslinje',
        en: 'Agreed delimitation line',
      },
      layers: 'Avtalt_avgrensningslinje',
      categoryId: 'maritime_borders',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoYttergrenseTilstodendeSone24NM',
      name: {
        nb: 'Yttergrense tilstøtende sone 24 NM',
        nn: 'Yttergrense tilstøytande sone 24 NM',
        en: 'Outer limit of contiguous zone 24 NM',
      },
      layers: 'Yttergrense_for_tilstotende_sone',
      categoryId: 'maritime_borders',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoTerritorialgrense',
      name: {
        nb: 'Territorialgrense 12 NM',
        nn: 'Territorialgrense 12 NM',
        en: 'Territorial border 12 NM',
      },
      layers: 'Territorialgrense',
      categoryId: 'maritime_borders',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoGrunnlinje',
      name: {
        nb: 'Grunnlinje',
        nn: 'Grunnlinje',
        en: 'Baseline',
      },
      layers: 'Grunnlinje',
      categoryId: 'maritime_borders',
      groupid: 3,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoMaritimeGrenserNavn',
      name: {
        nb: 'Navn på maritime grenser',
        nn: 'Namn på maritime grenser',
        en: 'Names of maritime borders',
      },
      layers: 'Maritime_grenser_navn',
      categoryId: 'maritime_borders',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
      singleImage: true,
    },

    // --- Maritime områder layers ---
    {
      id: 'sjoIndreFarvann',
      name: {
        nb: 'Indre farvann',
        nn: 'Indre farvatn',
        en: 'Internal waters',
      },
      layers: 'Indre_farvann',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoTerritorialfarvann',
      name: {
        nb: 'Territorialfarvann',
        nn: 'Territorialfarvatn',
        en: 'Territorial waters',
      },
      layers: 'Territorialfarvann',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoSjoterritorium',
      name: {
        nb: 'Sjøterritorium',
        nn: 'Sjøterritorium',
        en: 'Maritime territory',
      },
      layers: 'Sjoterritorium',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoTilstotendeSone',
      name: {
        nb: 'Tilstøtende sone',
        nn: 'Tilstøytande sone',
        en: 'Contiguous zone',
      },
      layers: 'Tilstotende_sone',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoNorgesOkonomiskeSone',
      name: {
        nb: 'Norges økonomiske sone',
        nn: 'Noregs økonomiske sone',
        en: "Norway's economic zone",
      },
      layers: 'Norges_okonomiske_sone',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoFiskevernsonen',
      name: {
        nb: 'Fiskevernsonen ved Svalbard',
        nn: 'Fiskevernsona ved Svalbard',
        en: 'Fisheries protection zone Svalbard',
      },
      layers: 'Fiskevernsonen_ved_Svalbard',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoFiskerisonen',
      name: {
        nb: 'Fiskerisonen ved Jan Mayen',
        nn: 'Fiskerisona ved Jan Mayen',
        en: 'Fisheries zone Jan Mayen',
      },
      layers: 'Fiskerisonen_ved_Jan_Mayen',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoKontinentalsokkel',
      name: {
        nb: 'Norges kontinentalsokkel',
        nn: 'Noregs kontinentalsokkel',
        en: "Norway's continental shelf",
      },
      layers: 'Norges_kontinentalsokkel',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoLandareal',
      name: {
        nb: 'Landareal',
        nn: 'Landareal',
        en: 'Land area',
      },
      layers: 'Landareal',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
    },
    {
      id: 'sjoNavnMaritime',
      name: {
        nb: 'Navn på maritime områder',
        nn: 'Namn på maritime område',
        en: 'Names of maritime areas',
      },
      layers: 'Maritime_omraader_navn',
      categoryId: 'maritime_areas',
      groupid: 14,
      queryable: true,
      useLegendGraphic: true,
      singleImage: true,
    },
  ],
};
